// extracted by mini-css-extract-plugin
module.exports = {"contentBlock":"meet-the-team-module--contentBlock--2UU9u","teamMembers":"meet-the-team-module--teamMembers--2OshG"};